export default {
      id: "save-tax-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#save-tax",
      toString: function () {
        return this.url;
      }
    }